import { observer } from "mobx-react";
import { Spacer } from "../../components/Layout/Layout";
import { ManualSyncWrapper } from "../../components/ManualSync/ManualSyncWrapper";
import LocationCameras from "../../components/location/LocationCameras";
import {
  EditLocationActions,
  LocationEditForm,
} from "../../components/location/LocationEditForm";
import LoadingSpinner from "../../ui-lib/components/Loading/LoadingSpinner";
import Divider from "../../ui-lib/components/Divider/Divider";
import useTranslations from "../../core/i18n/useTranslations";
import useSharedLocation from "./SharedLocationContext/useSharedLocationContext";
import { useRef } from "react";

const LocationGeneral = () => {
  const t = useTranslations();
  const { location, isLoading, fetchLocation } = useSharedLocation();
  const editLocationRef = useRef<EditLocationActions>(null);

  return (
    <>
      <h1>{t("Locations:details_page_title")}</h1>
      <Spacer size={8} />
      <p>{t("Locations:details_page_description")}</p>

      <Spacer size={32} />

      <h2>{t("Locations:basic_details_title")}</h2>
      <Spacer size={8} />
      <p>{t("Locations:basic_details_description")}</p>
      <Spacer size={16} />
      {(location === undefined || isLoading) && (
        <LoadingSpinner theme="primary" />
      )}
      {location && !isLoading && (
        <LocationEditForm location={location} ref={editLocationRef} />
      )}
      <Spacer size={16} />
      <Divider vertical={false} />
      <Spacer size={32} />
      {location?.id && <LocationCameras locationId={location.id.toString()} />}
      <ManualSyncWrapper
        clusterData={{
          lastSync: location?.lastClusterSync,
          latestSyncAttempt: location?.lastClusterSyncAttempt,
        }}
        refetchFunc={fetchLocation}
      />
    </>
  );
};

export default observer(LocationGeneral);
